import { WcroYVault__factory } from '@contracts';
import { formatUnits } from 'ethers/lib/utils';
import { VenoSDKModule } from './base';
import { getWcroUsdPrice, wrapSdkTransaction } from './util';
export default class WcroYVaultModule extends VenoSDKModule {
    constructor(sdk) {
        super(sdk);
        this.contractFactory = WcroYVault__factory;
        this.contractAddress = this.sdk.addresses.wcroYVault;
    }
    async deposit(amount, recipient) {
        return await wrapSdkTransaction(this.getContract()['deposit(uint256,address)'](amount, recipient));
    }
    async withdraw(amount, recipient) {
        return await wrapSdkTransaction(this.getContract()['withdraw(uint256,address)'](amount, recipient));
    }
    async balanceOf(account) {
        return this.getContract().balanceOf(account);
    }
    // from vLCRO-CRO to WCRO
    async exchangeRate() {
        return this.getContract().pricePerShare();
    }
    async allowance(account, operator) {
        return this.getContract().allowance(account, operator);
    }
    async approve(operator, amount) {
        return await wrapSdkTransaction(this.getContract().approve(operator, amount));
    }
    async getTokenAssetPrice() {
        return getWcroUsdPrice().catch(() => 0);
    }
    async getTvl() {
        const [totalShares, pricePerShare, wcroUsdPrice] = await Promise.all([
            this.getContract().totalSupply(),
            this.getContract().pricePerShare(),
            this.getTokenAssetPrice(),
        ]);
        const totalSharesHuman = parseFloat(formatUnits(totalShares, 18));
        const pricePerShareHuman = parseFloat(formatUnits(pricePerShare, 18));
        const totalTokens = totalSharesHuman * pricePerShareHuman;
        const totalValueFixed = totalTokens * (wcroUsdPrice ?? 0);
        return totalValueFixed;
    }
}
